/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：285__part-8
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_610 from /* 610 */"../../610"
var pt = {
  icon: {
    tag: "svg",
    attrs: {
      viewBox: "64 64 896 896",
      focusable: "false"
    },
    children: [
      {
        tag: "path",
        attrs: {
          d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
        }
      }
    ]
  },
  name: "exclamation-circle",
  theme: "filled"
}
export { pt }
